module.exports = __webpack_public_path__ + "static/img/200304.1685ed6c.png";